var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.613 2.21.094.083 17 17a1 1 0 0 1-1.32 1.497l-.094-.083-2.422-2.42a10.902 10.902 0 0 1-5.494 1.698l-.371.005a10.458 10.458 0 0 1-9.31-5.354l-.1-.184-.062-.108A5.288 5.288 0 0 1 2.42 9.88l.116-.25.166-.32A9.843 9.843 0 0 1 5.606 6.02L3.293 3.707a1 1 0 0 1 1.32-1.497zm-.137 8.022-.151.29a3.284 3.284 0 0 0-.09 2.732l.068.153.02.032a8.463 8.463 0 0 0 7.378 4.55l.293.001a8.896 8.896 0 0 0 4.42-1.16l-1.806-1.808a4.026 4.026 0 0 1-4.504.54l-.186-.102A4.01 4.01 0 0 1 8.5 9.986a3.83 3.83 0 0 1 .444-.627l-1.899-1.9a7.853 7.853 0 0 0-2.569 2.773zm16.811-.9.162.3a5.367 5.367 0 0 1 .11 4.464l-.115.251-.061.115-.069.115a1 1 0 0 1-1.788-.894l.061-.115.064-.106a3.365 3.365 0 0 0 .09-2.751l-.08-.18-.138-.256a8.443 8.443 0 0 0-7.241-4.296l-.34.002-.112.005-.402.03-.064.003-.116-.001a1 1 0 0 1-.09-1.985l.568-.045.166-.007h.078a10.436 10.436 0 0 1 9.317 5.352zm-11.056 1.654a2.013 2.013 0 0 0 .704 2.752c.73.428 1.619.347 2.252-.136l-2.821-2.821a1.942 1.942 0 0 0-.135.205z",
    fill: "#1B3DF2",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsEyeOff);
export default __webpack_public_path__ + "static/media/icons-eye-off.d223e42dcb9210d2ca0a1621daec3e8c.svg";
export { ForwardRef as ReactComponent };